import { IDictionary, IDropdownOption } from 'office-ui-fabric-react';
import { getControlTypesFromService, postValidateDesigner, ioException, getCaseServiceTypesFromService, getLayoutPanelFromService, getEntityFieldsFromService, getEntityFormsFromService, getEntityViewsFromService } from './io';
import { IControl, IdHelper, IProperty, IOutputValue, IComponent, PropertyHelper, IControlLayoutPanel, IFieldDictionary, IFieldConfig, ModalHelper, ActionHelper, IFilterPropertyDictionary, IQuickForm, IQuickFormLayout, IQuickFormSection, EPropertyTypes, IControlType, EValueType } from '../helpers';
import store from '../store/store';
import types from '../store/types';
import { Promise } from 'es6-promise';
import { reject } from 'promise';

interface IControlDragData {
	componentId: string;
	controlIndex: number;
	layoutPanelIndex: number;
}

export class ControlHelper {

	public static loadControlTypes(): Promise<IDropdownOption[]> {

		var promise = new Promise((resolve, reject) => {

			getControlTypesFromService().then(
				(response) => {

					let controlTypes: IDropdownOption[] = response.map(type => { return { key: type, text: type }; });

					store.dispatch({
						type: types.SET_CONTROL_TYPES,
						controlTypes: controlTypes
					});
					resolve(controlTypes);
				}, reject
			).catch(
				(error) => {
					reject(error);
				}
			);

		});
		return promise;
	}

	public static loadCaseServiceTypes = (): Promise<any> => {
		return getCaseServiceTypesFromService().then((serviceTypes: any) => {

			store.dispatch({
				type: types.SET_CASE_SERVICE_TYPES,
				caseServiceTypes: serviceTypes

			})
		});
	}

	public static addNewLayoutPanel = (componentId: string): Promise<any> => {
		return getLayoutPanelFromService().then((layoutPanel: any) => {
			store.dispatch({
				type: types.ADD_LAYOUT_PANEL,
				componentId: componentId,
				layoutPanel: layoutPanel

			})
		});
	}

	public static drag = (e, componentId: string, controlIndex: number, layoutPanelIndex: number) => {
		let dragData: IControlDragData = {
			componentId: componentId,
			controlIndex: controlIndex,
			layoutPanelIndex: layoutPanelIndex
		};
		e.dataTransfer.setData("dragData", '' + JSON.stringify(dragData));
	};

	// Commented out because there can be multiple lists of controls in the new version.
	// public static drop = (e, toIndex: number) => {

	// 	e.preventDefault();

	// 	let dragDataString: string = e.dataTransfer.getData("dragData");
	// 	if(dragDataString && dragDataString.length) {
	// 		let dragData: IControlDragData = JSON.parse(dragDataString);
	// 		let componentId: string = dragData.componentId;
	// 		let fromIndex: number = dragData.controlIndex;
	// 		store.dispatch({ type: types.DROP_CONTROL, componentId: componentId, fromIndex: +fromIndex, toIndex: toIndex });	
	// 	}

	// };
	public static drop = (e, toIndex: number, toLayoutPanelIndex: number) => {

		e.preventDefault();

		let dragDataString: string = e.dataTransfer.getData("dragData");
		if (dragDataString && dragDataString.length) {
			let dragData: IControlDragData = JSON.parse(dragDataString);
			let componentId: string = dragData.componentId;
			let fromIndex: number = dragData.controlIndex;
			let fromLayoutPanelIndex: number = dragData.layoutPanelIndex;
			store.dispatch({ type: types.DROP_CONTROL_WITH_LAYOUT_PANEL, componentId: componentId, fromIndex: +fromIndex, toIndex: toIndex, fromLayoutPanelIndex: +fromLayoutPanelIndex, toLayoutPanelIndex: toLayoutPanelIndex });
		}

	};

	public static allowDrop = (e) => {
		e.preventDefault();
	};

	public static createLayoutPanelsFromControls = (componentId: string, layoutPanels: IControlLayoutPanel[]) => {
		// store.dispatch({ type: types.CREATE_LAYOUT_PANELS, componentId: componentId, layoutPanels: layoutPanels });
		store.getState().processState.components[componentId].ControlBlock.LayoutPanels = layoutPanels;
		store.dispatch({ type: types.UPDATE_CONTROL_BLOCK, controlBlock: store.getState().processState.components[componentId].ControlBlock });
	}

	public static createControl(componentId: string, template: IControl): IControl {

		template.OutputValues = template.OutputValues ? template.OutputValues.map(output => {
			output.Id = IdHelper.newGuid();
			return output;
		}) : template.OutputValues;

		return {
			ControlId: '',
			ComponentId: componentId,
			OutputValues: template.OutputValues,
			ControlType: template.ControlType,
			Properties: template.Properties
		};
	}

	public static shouldOverwriteOutputName = (name: string, previousLabel: string): boolean => {
		return !name || !name.length || name === previousLabel || name === 'AnswerValue';
	};

	// reset all the entity name related variables
	public static resetAllEntityStateVariables() {
		store.dispatch({
			type: types.REMOVE_CONTROL_FIELD_FROM_METADATA,
		})
		store.dispatch({
			type: types.SET_CONTROL_ENTITY_VIEWS,
			entityViews: null
		})
		store.dispatch({
			type: types.SET_CONTROL_ENTITY_FORMATTED_ATTRIBUTES,
			entityFormattedAttributes: null
		});
		store.dispatch({
			type: types.SET_CONTROL_ENTITY_VIEW_COLUMNS,
			entityViewColumns: null
		})
		store.dispatch({
			type: types.SET_CONTROL_ENTITY_FORMS,
			entityForms: null
		});

	}


	// Update properties for action with Create Record option
	public static changeEntityForm = (key: string, value: any, control: IControl, propertyFilters: IFilterPropertyDictionary) => {

		store.dispatch({
			type: types.SET_IS_PROPERTY_CHANGED,
			value: true
		});

		let previousLabel = PropertyHelper.getPropertyValue(control.Properties, 'Label');
		let ctrl = PropertyHelper.updateProperty(control, key, value);
		PropertyHelper.resolveAdjustedFields(control.Properties, propertyFilters, key, value, true);

		if (ctrl.OutputValues) {
			let primaryOutput = ctrl.OutputValues[0];

			if (key === 'Label' && ActionHelper.shouldOverwriteOutputName(primaryOutput.Name, previousLabel)) {
				ctrl.OutputValues[0].Name = value;
			}
		}

		// If the changed value comes from Entity Name field, fetch necessary fields for the selected entity name.
		// Store the fields in the state to update the values in the Fields Name dropdown.
		if (key === 'Entity Name') {
			// set loading to false
			// store.dispatch({
			// 	type: types.SET_ARE_ENTITY_FORMS_LOADING,
			// 	value: true
			// });

			ControlHelper.loadEntityForms(value).then(x => {
				// set loading to false
				// store.dispatch({
				// 	type: types.SET_ARE_ENTITY_FORMS_LOADING,
				// 	value: false
				// });

			})
		}

	}

	// Update properties for action with Create Record option
	public static changeEntityView = (key: string, value: any, control: IControl, propertyFilters: IFilterPropertyDictionary) => {

		store.dispatch({
			type: types.SET_IS_PROPERTY_CHANGED,
			value: true
		});

		let previousLabel = PropertyHelper.getPropertyValue(control.Properties, 'Label');
		let ctrl = PropertyHelper.updateProperty(control, key, value);
		PropertyHelper.resolveAdjustedFields(control.Properties, propertyFilters, key, value, true);

		if (ctrl.OutputValues) {
			let primaryOutput = ctrl.OutputValues[0];

			if (key === 'Label' && ActionHelper.shouldOverwriteOutputName(primaryOutput.Name, previousLabel)) {
				ctrl.OutputValues[0].Name = value;
			}
		}

		// If the changed value comes from Entity Name field, fetch necessary fields for the selected entity name.
		// Store the fields in the state to update the values in the Fields Name dropdown.
		if (key === 'Entity Name') {

			// set entity views loading to true
			store.dispatch({
				type: types.SET_ARE_ENTITY_VIEWS_LOADING,
				value: true
			});

			ControlHelper.loadEntityViews(value).then(x => {
				// set entity views loading to false
				store.dispatch({
					type: types.SET_ARE_ENTITY_VIEWS_LOADING,
					value: false
				});
			})
		}

	}


	public static GetControlsFromFormJSON = (form: IQuickForm, componentId: string, entityLogicalName: string, sectionDictionary: { [key: string]: string }, formControls: IControl[] = []) => {

		let formObject = form && form.value ? JSON.parse(form.value) : null;
		// let formattedAttribute = form && form.value ? JSON.parse(form.formattedAttributes) : null;
		let attributesMetadata = {};
		store.getState().modalState.controlConfig.fieldConfigs && store.getState().modalState.controlConfig.fieldConfigs.length ?
			store.getState().modalState.controlConfig.fieldConfigs.map(x => {
				attributesMetadata[x.FieldName] = x
			}) : null;

		if (!Object.keys(attributesMetadata).length)
			return;
		// let optionSet = form && form.value ? JSON.parse(form.optionSet) : null;
		// let attributesRequiredLevel: { [key: string]: string } = JSON.parse(form.attributesRequiredLevel);
		let allControls: IControl[] = [];
		let quickFormLayout: IQuickFormLayout[] = [];
		formObject && formObject.Tabs.$values.forEach(tab => {
			tab.Columns.$values.forEach(column => {

				column.Sections.$values.forEach(section => {
					let quickFormSection: IQuickFormSection = {
						title: section.Name,
						machineName: section.Name,
						isVisible: section.Visible,
						showLabel: section.ShowLabel
					};
					let quickFormControls: IControl[] = [];

					section.Visible && section.Rows.$values.forEach(row => {
						const cell = row.Cells.$values[0];
						if (cell) {

							let transientAttributes: string[] = ControlHelper.findKeysMatchingSubstring(attributesMetadata, cell.Control.DataFieldName + "_transient_");
							if (cell.Control.DataFieldName) {
								cell.Id = cell.Id.replace(/[{}]/g, '');
								if (cell.Control.DataFieldName && transientAttributes.length) {
									transientAttributes.forEach(x => {
										cell.Control.DataFieldName = x;
										// cell.Id = cell.Id + x.split("_transient_")[1];
										ControlHelper.addControl(allControls, quickFormControls, cell, attributesMetadata, componentId, formControls)
									})
								} else {
									ControlHelper.addControl(allControls, quickFormControls, cell, attributesMetadata, componentId, formControls)
								}
							}
						}

					});
					quickFormLayout.push({
						section: quickFormSection,
						controls: quickFormControls

					})
				})
			})
		});
		form.layout = quickFormLayout;

		store.dispatch({
			type: types.ADD_CONTROL_QUICK_FORM,
			quickForm: form,
		});

		// store.dispatch({
		// 	type: types.SET_SIDEBAR_FORM,
		// 	form: store.getState().quickFormState.forms.filter(x => x.formId === form.formId)[0],
		// 	entityLogicalName: entityLogicalName
		// });

	}

	public static addControl(allControls, quickFormControls, cell, attributesMetadata, componentId, formControls: IControl[] = []) {
		let rowProperties: IProperty[] = [];

		if (cell.ShowLabel && cell.Control.DataFieldName) {
			const propertyLabel: IProperty = {
				Name: "Label",
				Value: cell.Control.DataFieldName,
				Default: cell.Control.DataFieldName,
				Type: EPropertyTypes.string,
				IsPrimary: false,
			};
			rowProperties.push(propertyLabel);
		}

		let controlType: IControlType = {
			NameType: 'Textbox',
			OutputValueType: cell.Control.Type
		}

		switch (Object.keys(attributesMetadata).length && attributesMetadata[cell.Control.DataFieldName] && attributesMetadata[cell.Control.DataFieldName].ValueType) {
			case EValueType.optionSetValue:
				controlType.NameType = 'ListOfOptions';

				const propertyValueOptions: IProperty = {
					Name: 'Value Options',
					ValueOptions: Object.keys(attributesMetadata).length && attributesMetadata[cell.Control.DataFieldName] && attributesMetadata[cell.Control.DataFieldName].ValueType,
					Default: cell.Control.DataFieldName,
					Type: EPropertyTypes.string,
					IsPrimary: false,
					Value: null
				};
				rowProperties.push(propertyValueOptions);
				break;
			case EValueType.dateTime:
				// controlType.NameType = 'Date Time';
				// controlType.IconName = 'DateTime';
				// controlType.HasUIDefinedOutputs = false;
				// controlType.DefaultOutputValue = null;
				// controlType.OutputValueType = 3;
				break;
		}

		const propertyRequired: IProperty = {
			Name: "Required",
			Value: Object.keys(attributesMetadata).length ? attributesMetadata[cell.Control.DataFieldName].FieldRequired === "true" : false,
			Default: false,
			Type: EPropertyTypes.boolean,
			IsPrimary: false,
		};
		rowProperties.push(propertyRequired);

		const propertyReadOnly: IProperty = {
			Name: "Read Only",
			Value: cell.Control.Disabled,
			Default: false,
			Type: EPropertyTypes.boolean,
			IsPrimary: false,
		};
		rowProperties.push(propertyReadOnly);
		const friendlyName = Object.keys(attributesMetadata).length && attributesMetadata[cell.Control.DataFieldName] && attributesMetadata[cell.Control.DataFieldName].FriendlyName;
		const control: IControl = {
			IsInvisible: cell.Visible,
			ControlId: cell.Id,
			MachineName: cell.Control.DataFieldName,
			FriendlyName: friendlyName,
			ControlType: null,
			OutputValues: [],
			ComponentId: componentId,
			Value: formControls.length ? formControls.filter(x => x.ControlId === cell.Id && x.FriendlyName === friendlyName)[0].Value : "",

			// controlId: cell.Id,
			// controlType: controlType,
			// componentId: componentId,
			iterationStatus: []
			// controlKeyValues: {
			// 	controlId: cell.Id,
			// 	sharedJourneyComponentId: null
			// },
			// valid: EControlValidationStatus.unchecked,
			// dirty: EControlStatus.pristine,
			// errors: [],
			// properties: rowProperties,
			// outputValues: [outputValue]

		};
		allControls.push(control);
		quickFormControls.push(control);
	}
	public static findKeysMatchingSubstring(dictionary, substring): string[] {
		if (!(Object.keys(dictionary) && Object.keys(dictionary).length))
			return [];
		const matchingKeys: string[] = Object.keys(dictionary).filter(key => key.indexOf(substring) !== -1);
		return matchingKeys;
	}

	// Fetch forms for the selected entity
	public static loadEntityForms = (entity?: string, onload?: boolean, fields?: IFieldDictionary): Promise<any> => {
		return getEntityFormsFromService(entity).then((entityForms: any) => {

			// set loading to true
			// store.dispatch({
			// 	type: types.SET_ARE_ENTITY_FORMS_LOADING,
			// 	value: true
			// });

			// Filter fields by requiredFields
			let requiredFields = {};
			let optionalFields = {};
			var filteredFields;

			// If there is no error fetching the entity-related fields
			if (!entityForms.Error && entityForms.Error !== '') {

				// Object.keys(entityForms).forEach(element => {
				// 	const test = JSON.parse(entityForms[element]);
				// 	entityForms[element] = JSON.parse(entityForms[element]);
				// });
				// Update fieldConfigs.
				// store.dispatch({
				// 	type: types.ADD_FIELD_FROM_METADATA,
				// 	fieldConfig: fields,
				// });

				const checkJsonEquals = JSON.stringify(store.getState().modalState.controlConfig.enityViews) === JSON.stringify(entityForms);
				if (checkJsonEquals) {

					// Remove field error.
					store.dispatch({
						type: types.REMOVE_FIELD_ERROR
					});

				} else {

					// Remove field error.
					store.dispatch({
						type: types.REMOVE_FIELD_ERROR
					});

					let entityFormsKeyText = [];
					let entityFormsFieldsKeyText = [];
					Object.keys(entityForms).map((val, index) => {
						entityFormsKeyText.push(
							{
								key: val,
								text: Object.keys(JSON.parse(entityForms[val]))[0]
							}
						);
						entityFormsFieldsKeyText.push(
							{
								key: val,
								text: JSON.parse(entityForms[val])[Object.keys(JSON.parse(entityForms[val]))[0]]
							}
						);
					});
					store.dispatch({
						type: types.SET_CONTROL_ENTITY_FORMS,
						entityForms: entityFormsKeyText
					});

					// store.dispatch({
					// 	type: types.SET_CONTROL_ENTITY_FORMS_FIELDS,
					// 	entityFormsFeilds: entityFormsFieldsKeyText
					// });
					const quickCreateFormValue = store.getState().modalState.controlConfig.control.Properties.filter(x => x.Name === "Quick Create Form");
					let form: IQuickForm = {
						formId: null,
						formXML: '',
						formXMLDictionary: {},
						value: null,
						attributeMetadata: ''
					};

					if (quickCreateFormValue.length && quickCreateFormValue[0].Value) {
						form.formId = quickCreateFormValue[0].Value;
						form.value = entityFormsFieldsKeyText.filter(x => x.key === quickCreateFormValue[0].Value)[0].text;
					}
					// form.formId = control.controlId;
					// const sectionDictionary: { [key: string]: string } = SidebarHelper.extractFriendlySectionNamesFromXML(form.formXML);
					// form.formXMLDictionary = sectionDictionary;
					// form.attributeMetadata = JSON.parse(form.attributeMetadata);

					// add form to state
					// store.dispatch({
					// 	type: types.ADD_QUICK_FORM,
					// 	form: form
					// });

					store.dispatch({
						type: types.SET_CONTROL_QUICK_FORMS,
						quickForms: []
					})

					//check if the formid is same
					const formFieldProperty = store.getState().modalState.controlConfig.control.Properties.filter(x => x.Name === "Quick Create Form Fields");
					const isFormIdSame =
						formFieldProperty.length && formFieldProperty[0].Value ?
							form.formId === JSON.parse(formFieldProperty[0].Value).formId :
							false;
					let formControls: IControl[] = [];
					if (isFormIdSame)
						formControls = JSON.parse(formFieldProperty[0].Value).layout.map(x => x.controls).flat();
					// set quick forms
					// const quickCreateFormValue = store.getState().modalState.controlConfig.control.Properties.filter(x => x.Name === "Quick Create Form");
					if (quickCreateFormValue.length && quickCreateFormValue[0].Value)
						ControlHelper.GetControlsFromFormJSON(form, quickCreateFormValue[0].Value, "", null, formControls);

					filteredFields = Object.keys(entityForms).reduce(function (filteredFields, key) {
						(entityForms[key].isMandatory && entityForms[key].isMandatory.toLowerCase() === 'false') ? optionalFields[key] = entityForms[key].isMandatory
							: requiredFields[key] = entityForms[key].isMandatory;
						return filteredFields;
					}, {});
					!onload ?
						store.dispatch({
							type: types.REMOVE_FIELD_FROM_METADATA,
						})
						: null;

				}


			} else {
				// Set field error in the state
				Object.keys(entityForms).map((val, index) => {

					store.dispatch({
						type: types.ADD_FIELD_ERROR,
						errorTitle: val,
						errorMessage: entityForms[val],
					});

				});


			}

			// set loading to false
			// store.dispatch({
			// 	type: types.SET_ARE_ENTITY_FORMS_LOADING,
			// 	value: false
			// });

			ModalHelper.scrollToBottom();

			return store.getState().modalState.controlConfig.entityViews;
		})
	}

	// Fetch views for the selected entity
	public static loadEntityViews = (entity?: string, onload?: boolean, fields?: IFieldDictionary): Promise<any> => {
		var promise = new Promise((resolve, reject) => {

			getEntityViewsFromService(entity).then((entityViews: any) => {

				let formattedAttributeData;
				// Filter fields by requiredFields
				let requiredFields = {};
				let optionalFields = {};
				var filteredFields;
				let entityViewsClone = {};
				// If there is no error fetching the entity-related fields
				if (!entityViews.Error && entityViews.Error !== '') {
					formattedAttributeData = entityViews.formattedData;

					Object.keys(entityViews.entityViewsMetadata).forEach(element => {
						entityViewsClone[element] = JSON.parse(entityViews.entityViewsMetadata[element]);
					});
					// Update fieldConfigs.
					// store.dispatch({
					// 	type: types.ADD_FIELD_FROM_METADATA,
					// 	fieldConfig: fields,
					// });

					const checkJsonEquals = JSON.stringify(store.getState().modalState.controlConfig.entityViews) === JSON.stringify(entityViews);
					if (checkJsonEquals) {

						// Remove field error.
						store.dispatch({
							type: types.REMOVE_FIELD_ERROR
						});

					} else {

						// Remove field error.
						store.dispatch({
							type: types.REMOVE_FIELD_ERROR
						});

						var entityViewsKeyText = [];
						Object.keys(entityViewsClone).map((val, index) => {
							entityViewsKeyText.push(
								{
									key: val,
									text: JSON.stringify(entityViewsClone[val])
								}
							);
						});
						store.dispatch({
							type: types.SET_CONTROL_ENTITY_VIEWS,
							entityViews: entityViewsKeyText
						});

						let isDatatable: boolean = store.getState().modalState.controlConfig.control.ControlType.NameType.toLowerCase() === "datatable" ||
							store.getState().modalState.controlConfig.control.ControlType.NameType.toLowerCase() === "get view";
						if (isDatatable) {
							let control = store.getState().modalState.controlConfig.control;
							let layoutViewValue = control.Properties.filter(y => y.Name.toLowerCase() === "layout view")[0].Value;
							let selectedLayoutView = null;
							if (entityViewsKeyText.filter(x => x.key === layoutViewValue).length)
								selectedLayoutView = JSON.parse(entityViewsKeyText.filter(x => x.key === layoutViewValue)[0].text).layoutjson ?
									JSON.parse(JSON.parse(entityViewsKeyText.filter(x => x.key === layoutViewValue)[0].text).layoutjson).Rows[0].Cells :
									[];

							store.dispatch({
								type: types.SET_IS_PROPERTY_CHANGED,
								value: true
							});

							const formattedAttributes = formattedAttributeData ? JSON.parse(formattedAttributeData) : null
							if (formattedAttributes) {
								let formattedAttributesKeyText: { [id: string]: string; } = {};
								Object.keys(formattedAttributes).map((key, index) => {
									formattedAttributesKeyText[key] = formattedAttributes[key];
								});

								store.dispatch({
									type: types.SET_CONTROL_ENTITY_FORMATTED_ATTRIBUTES,
									entityFormattedAttributes: formattedAttributesKeyText
								});

							}
							store.dispatch({
								type: types.SET_CONTROL_ENTITY_VIEW_COLUMNS,
								entityViewColumns: selectedLayoutView
							});
						}

						// filteredFields = Object.keys(entityViewsClone).reduce(function (filteredFields, key) {
						// 	(entityViewsClone[key] && entityViewsClone[key].isMandatory.toLowerCase() === 'false') ? optionalFields[key] = entityViewsClone[key].isMandatory
						// 		: requiredFields[key] = entityViewsClone[key].isMandatory;
						// 	return filteredFields;
						// }, {});
						!onload ?
							store.dispatch({
								type: types.REMOVE_FIELD_FROM_METADATA,
							})
							: null;
					}

				} else {
					// Set field error in the state
					Object.keys(entityViews.entityViewsMetadata).map((val, index) => {

						store.dispatch({
							type: types.ADD_FIELD_ERROR,
							errorTitle: val,
							errorMessage: entityViews.entityViewsMetadata[val],
						});

					});
				}

				ModalHelper.scrollToBottom();
				resolve(store.getState().modalState.controlConfig.entityViews)

				// return store.getState().modalState.controlConfig.entityViews;

			}).catch(
				(error) => {
					reject(error);
				}
			);
		});
		return promise;

	}

	// Fetch fields for the selected entity
	public static loadEntityFields = (entity: string, componentId: string, onload?: boolean, fields?: IFieldDictionary): Promise<any> => {
		return getEntityFieldsFromService(entity).then((entityFields: any) => {

			// if the component that made the api call is different than the currently opened component, perform no operation and return
			if (componentId !== (store.getState().modalState.controlConfig && store.getState().modalState.controlConfig.componentId)) {
				return;
			}

			// Filter fields by requiredFields
			let requiredFields = {};
			let optionalFields = {};
			var filteredFields;

			// If there is no error fetching the entity-related fields
			if (!entityFields.Error && entityFields.Error !== '') {

				Object.keys(entityFields).forEach(element => {
					const test = JSON.parse(entityFields[element]);
					entityFields[element] = JSON.parse(entityFields[element]);
				});

				const checkJsonEquals = JSON.stringify(store.getState().modalState.controlConfig.entityFields) === JSON.stringify(entityFields);
				if (checkJsonEquals) {

					// Remove field error.
					// store.dispatch({
					// 	type: types.REMOVE_FIELD_ERROR
					// });

				} else {
					// Remove field error.
					// store.dispatch({
					// 	type: types.REMOVE_FIELD_ERROR
					// });

					// store.dispatch({
					// 	type: types.SET_ENTITY_FIELDS,
					// 	entityFields: entityFields
					// });


					filteredFields = Object.keys(entityFields).reduce(function (filteredFields, key) {
						(entityFields[key].isMandatory.toLowerCase() === 'false') ? optionalFields[key] = entityFields[key].isMandatory
							: requiredFields[key] = entityFields[key].isMandatory;
						return filteredFields;
					}, {});
					!onload ?
						store.dispatch({
							type: types.REMOVE_FIELD_FROM_METADATA,
						})
						: null;

					let filedConfigData: IFieldConfig[] = [];
					Object.keys(entityFields).map((val, index) => {
						filedConfigData.push(
							{
								FieldName: val,
								FieldValue: '',
								ValueOptionsFieldValue: '',
								FieldType: entityFields[val].fieldType,
								ValueType: entityFields[val].valueType,
								FieldRequired: entityFields[val].isMandatory.toLowerCase() === 'true',
								FriendlyName: entityFields[val].friendlyName,
								LookupEntityReference: entityFields[val].referenceEntity,
								ValueOptions: entityFields[val].valueOptions
							}
						);

					});

					// Update fieldConfigs.
					store.dispatch({
						type: types.SET_CONTROL_FIELD_FROM_METADATA,
						fieldConfigs: filedConfigData,
					});

				}


			} else {
				// Set field error in the state
				Object.keys(entityFields).map((val, index) => {

					store.dispatch({
						type: types.ADD_FIELD_ERROR,
						errorTitle: val,
						errorMessage: entityFields[val],
					});

				});


			}

			ModalHelper.scrollToBottom();

			return store.getState().modalState.controlConfig.entityFields;
		})
	}


	public static getControlIcon = (type: string): string => {

		let icon: string;

		switch (type) {

			case 'Boolean':
				icon = 'CheckboxComposite';
				break;

			case 'Content Snippet':
				icon = 'PreviewLink';
				break;

			case 'Create Form':
				icon = 'Add';
				break;

			case 'Date Time':
				icon = 'DateTime';
				break;

			case 'Datatable':
			case 'Get View':
				icon = 'Table';
				break;

			case 'List Of Options':
				icon = 'Dropdown';
				break;

			case 'List Of Items':
				icon = 'BulletedList';
				break;

			case 'Numeric Value':
				icon = 'NumberField';
				break;

			case 'Multi Select Control':
				icon = 'MultiSelect';
				break;

			case 'Section':
				icon = 'Section';
				break;

			case 'LUIS Textbox':
			case 'Textbox':
				icon = 'TextField';
				break;

			case 'Google Map':
			case 'ESRI Map':
				icon = 'Globe';
				break;

			case 'File Upload':
				icon = 'OpenFile';
				break;

			case 'Address Search':
				icon = 'Search';
				break;

			case 'Booking':
				icon = 'Calendar';
				break;

		}

		return icon;

	};

}


// WEBPACK FOOTER //
// ./source/ts/helpers/control.ts